import { values, zipObject } from 'vtils'

export async function prepareData<T extends Record<string, any>>(
  getter: T,
): Promise<{
  [K in keyof T]: T[K] extends Promise<infer X> ? X : Awaited<T[K]>
}> {
  const res = await Promise.all(
    values(getter).map(v => (typeof v === 'function' ? v() : v)),
  )
  return zipObject(Object.keys(getter), res) as any
}
